const layoutTypes = {
  LAYOUT_TYPE_DEFAULT: "default",
  LAYOUT_TYPE_CUSTOM: "custom",
  LAYOUT_TYPE_BLANK: "blank",
}

export default layoutTypes
